
import axios from 'axios';
import { useApiClient } from './CommonService';

const ApiClient = axios.create({
  //baseURL: '',  // Replace with your API base URL
});

// Request Interceptor
ApiClient.interceptors.request.use(
  (config) => {

    // Attach token to headers if it exists
    /*   const token = localStorage.getItem('authToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      } */
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response Interceptor
ApiClient.interceptors.response.use(
  (response) => {
    console.log("Response from api client", response.data?.resultCode === 401)
    if (response.data?.resultCode === 401 || response.data?.resultCode === 403) {
      useApiClient();
    }


    // Process the response as needed
    return response;
  },
  (error) => {
    // Handle response error (e.g., unauthorized or other errors)
    if (error.response && error.response.status === 401) {
      //  console.log('Unauthorized - handling redirection or token refresh');
      // Logic to handle the unauthorized error (like redirect to login)
    }
    return Promise.reject(error);
  }
);




export default ApiClient;





